// i18n area 'apps' — locale sr-Latn-RS (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Script LATINO (srpska latinica, da ratificare).
// Sidecar anti-stantie: ../meta/apps.sr-Latn-RS.meta.json.
import type { enUS } from './apps'

export const srLatnRS: typeof enUS = {

  // Apps wave 1 (Annex R): container podman gestiti — supervisionati dal
  // worker su un nodo dichiarato; immagine = lockfile branch@digest (Annex Q)
  // con policy pinned/tracking; attacco L3 untagged con IP statico.
  apps: {
    title: 'Aplikacije',
    create: 'Kreiraj aplikaciju',
    createTitle: 'Kreirajte aplikaciju',
    editTitle: 'Izmenite aplikaciju',
    name: 'Ime',
    nameHint: 'DNS-1123, jedinstveno unutar scopea — nepromenljivo nakon kreiranja.',
    node: 'Čvor',
    nodeHint: 'Članski čvor koji je služi — eksplicitni placement (scheduler stiže kasnije).',
    image: 'Slika',
    editImageHint: 'Nova referenca se ponovo razrešava kroz matične podatke — gest pina/rollbacka.',
    imagePolicy: 'Policy',
    policyPinned: 'pinned',
    policyTracking: 'tracking',
    policyPinnedHint: 'Digest se pomera samo na komandu.',
    policyTrackingHint: 'Kotrlja se automatski kada refresh pomeri branch.',
    archMovePolicy: 'Cross-arch premeštanje',
    archMoveRefuse: 'refuse',
    archMoveReresolve: 'reresolve',
    archMovePolicyHint: 'Šta se dešava ako se app premesti na node druge arhitekture: refuse odbija premeštanje, reresolve iznova razrešava lockfile sa brancha na novoj arch — sadržaj se menja, i odgovor imenuje promenu digesta.',
    network: 'Mreža',
    networkHint: 'Untagged L3 priključak: fabric logička mreža (preporučena — gateway/DNS iz njenog jedinog izvora), overlay, ili goli host bridge (ne preporučuje se).',
    overlayPrefix: 'overlay:',
    fabricPrefix: 'fabric:',
    bridgePrefix: 'host bridge:',
    ipAssignment: 'Dodela IP adrese',
    ipStatic: 'Statička',
    ipAuto: 'Automatska (IPAM)',
    ipAssignmentHint_static: 'Adresu dajete vi, sada.',
    ipAssignmentHint_auto: 'IPAM bira slobodnu adresu iz opsega mreže rezervisanih za TVirt.',
    bridgeDiscouraged: 'Goli host bridge — NE PREPORUČUJE SE: TVirt ne zna ništa o njegovom adresiranju, pa se gateway i DNS moraju dati ručno. Preporučeni put je fabric logička mreža.',
    ip: 'IP',
    ipHint: 'Statička IPv4 adresa unutar podmreže priključka.',
    ipCidrHint: 'U CIDR obliku na golom bridgeu (npr. 192.168.1.10/24) — nema odakle izvesti prefiks.',
    gateway: 'Gateway',
    gatewayManualHint: 'Ručno — goli bridge ništa ne izvodi.',
    dnsServers: 'DNS serveri',
    dnsManualHint: 'Ručno, odvojeni zarezom — bar jedan.',
    rootKind: 'Root',
    rootEphemeral: 'efemeran',
    rootPersistent: 'trajan',
    rootEphemeralHint: 'Ponovo se kreira iz slike pri svakom ponovnom kreiranju; živi na klasterskom efemernom storageu.',
    rootEphemeralHintNamed: 'Ponovo se kreira iz slike pri svakom ponovnom kreiranju; živi na klasterskom efemernom storageu ({name}).',
    rootPersistentHint: 'Preživljava restarte; živi na storageu koji izaberete.',
    rootStorage: 'Root storage',
    editRootStorageHint: 'Root se ponovo renderuje na novom poolu — postojeći podaci se NE premeštaju sami.',
    volumes: 'Volumeni',
    volumeAdd: 'Dodaj volumen',
    volumeName: 'Ime',
    volumeMountPath: 'Putanja montiranja',
    volumeKind: 'Tip',
    volumeStorage: 'Storage',
    devices: 'Uređaji',
    deviceClassHint: 'Traži se KLASA (oznaka gpu-device ili usb-device), nikada određeni uređaj: prijavljeni čvor mora imati neki označen za Apps. Više Apps može koristiti isti uređaj — kontejner ga deli, ne oduzima ga domaćinu.',
    deviceSlot: 'Slot',
    deviceTag: 'Oznaka',
    deviceValue: 'Klasa',
    deviceUnresolved: 'trenutno se ništa ne razrešava',
    noDeviceTags: 'Još nema oznake vrste gpu-device ili usb-device: napravi je i dodeli uređajima označenim za Apps.',
    env: 'Okruženje',
    envHint: 'Jedan KLJUČ=vrednost po redu.',
    secretEnvTitle: 'Tajne promenljive',
    secretEnvNotice: 'Tajna vrednost se više nikada ne vraća iz API-ja: niko je ne čita ponovo, čak ni onaj ko ju je upisao. U checkpointu putuje zapečaćena masterpassom, pa će vraćanje bez masterpassa tražiti da je ponovo upišete.',
    secretEnvPromote: 'Učinite tajnom jednu od gore upisanih promenljivih:',
    secretEnvAdd: 'Dodaj tajnu promenljivu',
    secretEnvName: 'Ime',
    secretEnvValue: 'Vrednost',
    secretEnvKept: 'sačuvana — ostavite prazno da je ne menjate',
    secretEnvWithdrawWarning: 'Da biste prestali da tretirate kao tajnu promenljivu koja to već jeste, upišite joj novu vrednost: samo skidanje oznake bilo bi način da se PROČITA ono što ne izlazi iz storea. Uklanjanje promenljive je, naprotiv, briše.',
    secretEnvChip: 'tajno',
    startNow: 'Pokreni odmah (inače se aplikacija kreira zaustavljena)',
    deletePersistentIntro: 'Ova aplikacija ima trajne podatke — izaberite šta će biti sa njima:',
    deleteKeepData: 'Zadrži podatke (direktorijumi ostaju na svojim storageima, napušteni)',
    deletePurgeData: 'Obriši i podatke',
    phase: 'Faza',
    phase_running: 'U toku',
    phase_stopped: 'Zaustavljena',
    phase_error: 'Greška',
    phase_unknown: 'Nepoznata',
    desiredState: 'Željeno',
    wantedRunning: 'u toku',
    wantedStopped: 'zaustavljena',
    start: 'Pokreni',
    stop: 'Zaustavi',
    restart: 'Restartuj',
    refreshImage: 'Osveži sliku (usvoji novi @current)',
    logs: 'Logovi',
    logsTitle: 'Logovi',
    logsEmpty: 'Nema uhvaćenog izlaza.',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'App nije pokrenuta — shell zahteva živ kontejner. Njeni logovi se čitaju u bilo kom stanju.',
    shellConnect: 'Poveži',
    shellDisconnect: 'Prekini vezu',
    shellExited: 'Sesija je završena sa izlaznim kodom {code}.',
    shellEndedWithoutStatus: 'Sesija je završena bez izlaznog statusa: {reason}',
    shellRevoked: 'Ticket sesije više nije važeći — istekao je, ili je prijava koja ga je otvorila opozvana.',
    shellHint: 'Klikni na crno polje i kucaj: tasteri stižu do kontejnera. Ctrl+C i strelice rade; exit zatvara shell.',
    shellStatus: {
      connecting: 'Povezivanje…',
      connected: 'Povezana',
      ended: 'Završena'
    },
    deleteRunningError: 'Za {name} je željeno stanje „u toku“ — prvo je zaustavite.',

    // Dialog standard (round #156): i tab del dettaglio e i campi contract
    // mancanti — ogni campo dell'App visibile, lucchetti col perché.
    tabs: {
      general: 'Opšte',
      image: 'Slika',
      network: 'Mreža',
      storage: 'Storage',
      devices: 'Uređaji',
      observed: 'Posmatrano'
    },
    attachment: 'Priključak',
    runningDigest: 'Digest u toku',
    lastError: 'Poslednja greška',
    reportObservedAt: 'Poslednji izveštaj workera',
    desiredStateLock: 'Njime upravljaju akcije Pokreni/Zaustavi — nikada direktna izmena.',
    ipEditDisabledHint: 'Izmenljivo samo uz statičku dodelu.',
    derivedFromNetworkHint: 'Izvedeno iz jedinog izvora mreže — ručno samo na golom bridgeu sa statičkom IP adresom.',
    ephemeralUnset: 'nije konfigurisano',
    ephemeralMissing: 'Efemerni storage za aplikacije nije konfigurisan — kreiranje aplikacije sa efemernim delovima (root ili volumeni) se odbija dok ga ne podesite.',
    ephemeralCurrent: 'Efemerni storage za aplikacije: {name}',
    ephemeralMissingCreate: 'Ova aplikacija ima efemerne delove, ali efemerni storage za aplikacije nije podešen — kreiranje će biti odbijeno. Prvo ga podesite sa banera stranice Aplikacije.',
    setEphemeral: 'Podesi efemerni storage',
    changeEphemeral: 'Promeni efemerni storage',
    setEphemeralTitle: 'Podesite efemerni storage za aplikacije',
    changeEphemeralTitle: 'Promenite efemerni storage za aplikacije',
    ephemeralStorageHint: 'PODRAZUMEVANO na nivou klastera: dir-like pool u kojem žive efemerni rootovi i efemerni volumeni svake aplikacije, osim ako aplikacija ne deklariše sopstveni override. Promena se ne primenjuje u hodu i ništa ne restartuje: važi od sledećeg pokretanja svake aplikacije — efemerni podaci se ne premeštaju.',
    ephemeralPool: 'Storage pool',
    ephemeralOverride: 'Efemerni storage (override po aplikaciji)',
    ephemeralOverrideInherit: 'Nasleđuje podrazumevano za klaster',
    ephemeralOverrideInheritNamed: 'Nasledi podrazumevanu vrednost klastera ({name})',
    ephemeralOverrideHint: 'Pool po aplikaciji za efemerni root i volumene — ostavite prazno da nasledi podrazumevanu vrednost klastera. Promena se ne primenjuje u hodu i ništa ne restartuje: važi od sledećeg pokretanja (efemerni podaci se ponovo rađaju prazni na novom poolu) i zahteva dozvolu app.ephemeralStorage.set.',
    ephemeralOverrideTag: 'override',

    imageAnyBranch: 'Sve grane',
    imageBranchHint: 'Sužava slike na one koje imenuje ova grana; bez grane vide se sve slike spremišta.',
    imageDigestHint: 'Sadržaj: bira se iz tabele digesta, koja nosi njegovo poreklo i arhitekturu. Ista grana nudi po jedan za arhitekturu i nisu zamenljivi.',
    imageLockfile: 'Razrešena referenca',
    imageNoImages: 'Nema slika u kešu za ovo spremište — preuzmi jednu iz OCI slika.',
    imageHeadNotCached: 'nije u kešu — preuzima se pri pokretanju',
    imageNoRegistries: 'Nije registrovano nijedno spremište: registruj jedno da bi mogao da izabereš sliku.',
    imageChosenHint: 'Slika se bira kaskadom u dijalogu izmene: referenca se nikada ne kuca ručno.',
    registerRepositoryHint: 'Registrovanje ništa ne preuzima: čini spremište praćenim, da bi se slika mogla izabrati bez napuštanja ovog dijaloga.',
    registerRepositoryBranchHint: 'Opciono: prva grana koju treba pratiti (npr. latest).',
    registerRepositoryElsewhere: 'Traženo spremište nije registrovano: registrovanje se radi u odeljku OCI slike, od strane nekoga ko ima dozvolu.'
  },

  // Template CT (round K2 #63): gli oggetti CT MATERIALIZZATI — l'import da
  // catalogo è l'unico ingresso; i file si caricano dentro i cataloghi.
  cts: {
    createAction: 'Kreiraj CT',
    createTitle: 'Kreirajte kontejner iz šablona',
    createError: 'Kontejner nije kreiran',
    template: 'CT šablon',
    noTemplates: 'Još nema CT šablona — uvezite jedan u odeljku CT šabloni',
    resources: 'Resursi',
    node: 'Čvor',
    phase: {
      defined: 'Nikada upaljen',
      materializing: 'U materijalizaciji',
      ready: 'Spreman',
      starting: 'Pokreće se',
      running: 'U toku',
      stopping: 'Zaustavlja se',
      stopped: 'Zaustavljen',
      deleting: 'Briše se',
      error: 'U grešci'
    },
    actions: {
      start: 'Pokreni',
      stop: 'Zaustavi',
      restart: 'Restartuj',
      markTemplate: 'Unapredi u CT šablon',
      error: 'Akcija je odbijena'
    },
    markTemplate: {
      confirmTitle: "Unaprediti '{name}' u CT šablon?",
      confirmBody: 'Kontejner napušta ovu listu i prelazi među CT šablone, odmah spreman da stvara nove CT-ove. Njegovi metapodaci ostaju izmenljivi, i u svakom trenutku ga možete vratiti u CT.',
      confirm: 'Unapredi',
      moved: "'{name}' je sada CT šablon — naći ćete ga u odeljku CT šabloni."
    },
    stopCause: {
      api: 'Zaustavljen preko TVirta',
      'ct-exit': 'Kontejner je izašao sam od sebe',
      'host-reboot': 'Umro sa restartom čvora',
      'start-failed': 'Pokretanje nije uspelo — greška zadatka kaže šta nedostaje i kako se popravlja'
    },

    console: 'Konzola',
    consoleUnavailable: 'Kontejner nije pokrenut — konzoli je potreban živ kontejner. Njegovi logovi se pak čitaju u bilo kom stanju.',
    consoleNoTemplate: 'Šablon nikada ne radi, pa nema konzolu: kreirajte iz njega CT i otvorite njegovu.',
    consoleConnect: 'Poveži',
    consoleDisconnect: 'Prekini vezu',
    consoleReconnect: 'Poveži ponovo',
    consoleTakenBy: 'Ovu konzolu je preuzeo drugi operater ({user}). Jedna konzola po kontejneru: ponovno povezivanje je vraća vama.',
    consoleHint: 'Kliknite na crno polje i kucajte: tasteri stižu do kontejnera. Ctrl+C i strelice rade.',
    consoleEndpointDown: 'Pristupna tačka konzole ne može da se otvori na čvoru koji opslužuje container: {cause}',
    shell: 'Shell',
    shellTitle: 'Shell',
    shellUnavailable: 'Container nije pokrenut — shell zahteva živ container. Njegovi logovi se čitaju u bilo kom stanju.',
    shellNoTemplate: 'Template se nikad ne izvršava, pa nema shell: napravi CT od njega i otvori njegov.',
    shellConnect: 'Poveži',
    shellDisconnect: 'Prekini vezu',
    shellExited: 'Sesija je završena sa izlaznim kodom {code}.',
    shellEndedWithoutStatus: 'Sesija je završena bez izlaznog statusa: {reason}',
    shellRevoked: 'Ticket sesije više nije važeći — istekao je, ili je prijava koja ga je otvorila opozvana.',
    shellHint: 'Klikni na crno polje i kucaj: tasteri stižu do kontejnera. Ctrl+C i strelice rade; exit zatvara shell.',
    shellStatus: {
      connecting: 'Povezivanje…',
      connected: 'Povezana',
      ended: 'Završena'
    },
    rootPassword: 'Lozinka roota',
    rootPasswordHint: 'Upisuje se jednom u kopirani rootfs (kao hash, više se ne prikazuje). Slike distribucija nemaju lozinku roota: bez nje je shell jedini ulaz.',
    sshKeys: 'Javni SSH ključevi roota',
    sshKeysHint: 'Jedan javni OpenSSH ključ po redu, u root/.ssh/authorized_keys.',
    consoleStatus: {
      connecting: 'Povezivanje…',
      connected: 'Povezana',
      reconnecting: 'Ponovno povezivanje…'
    },
    logs: 'Logovi',
    logsTitle: 'Logovi',
    logsEmpty: 'Nema uhvaćenog izlaza.',
    logsSource: 'Koji log',
    logsSourceConsole: 'Konzola inita kontejnera — zašto se servis unutra nije pokrenuo',
    logsSourceSupervisor: 'Nadzornik liblxc — zašto kontejner nikada nije ni stigao da se pokrene',
    logsNeverStarted: 'Nikada nije pokrenut, pa još nema ništa zabeleženo — pokrenite ga i logovi će biti tu čak i ako pokretanje ne uspe.',
    logsNoTemplate: 'Šablon nikada ne radi, pa nikada ništa nije ni zabeležio.',
    logsError: 'Logovi nisu uhvaćeni',

    // Dialog standard (round #156): i tab del dettaglio condivisi dalle
    // liste CT e Template CT, più i lucchetti col perché.
    tabs: {
      general: 'Opšte',
      hardware: 'Hardver',
      network: 'Mreža',
      provenance: 'Poreklo'
    },
    templateFlag: 'CT šablon',
    templateLock: 'Menja se samo akcijama Unapredi / Vrati u CT — nikada direktna izmena.',
    sourceLock: 'Poreklo, zabeleženo pri nastanku — nikada se ne prepisuje; mrtav izvor ostavlja golu referencu.',
    storageLock: 'Fiksirano pri kreiranju — premeštanje rootfs stabla je budući round.',
    startedAt: 'Pokrenut',
    lastStop: 'Poslednje zaustavljanje',
    editNicsTitle: 'Izmenite mreže',
    nicDisconnected: 'otkačena'
  },
  ctTemplates: {
    title: 'CT šabloni',
    importAction: 'Uvezi iz kataloga',
    importTitle: 'Uvezite CT šablon iz kataloga',
    importSubmit: 'Uvezi',
    importError: 'Uvoz je odbijen',
    importHint: 'Materijalizacija kopira rootfs na izabrani storage — datoteka kataloga ostaje netaknuta. Da biste dodali nove datoteke, prvo ih otpremite u katalog.',
    sourceFile: 'Datoteka CT šablona',
    sourceFileHint: 'Datoteke ct-rootfs izabranog kataloga, samo one spremne',
    noFiles: 'Nema spremne ct-rootfs datoteke u ovom katalogu — prvo otpremite jednu sa stranice kataloga',
    source: 'Izvorna datoteka',
    rootfsStorage: 'Storage za rootfs',
    rootfsStorageHint: "Gde živi raspakovano rootfs stablo — storage zasnovan na filesystemu, sa dovoljno slobodnog prostora za raspakovanu veličinu plus oko 1 GiB rezerve (u suprotnom uvoz ne uspeva).",
    resources: 'Resursi',
    cores: 'vCPU',
    memoryMiB: 'Memorija (MiB)',
    cpuLimit: 'CPU limit',
    cpuLimitHint: 'Ekvivalenti host jezgara (npr. 1.5); prazno = bez ograničenja',
    cpuUncapped: 'bez ograničenja',
    cpuWeight: 'CPU težina',
    hostname: 'Hostname',
    hostnameHint: 'Prazno = ime samog CT-a',
    nameservers: 'DNS nameserveri',
    dnsHint: 'Odvojeni zarezom; prazno = nasleđuju se od hosta',
    searchDomains: 'DNS domeni pretrage',
    dnsInherited: 'Nasleđeno od hosta',
    networks: 'Mreže',
    nicSlot: 'NIC slot',
    phase: {
      materializing: 'U materijalizaciji',
      ready: 'Spreman',
      deleting: 'Briše se',
      error: 'Greška'
    },
    exportAction: 'Izvezi u katalog',
    exportTitle: 'Izvezite u katalog',
    exportSubmit: 'Izvezi',
    exportError: 'Izvoz je odbijen',
    exportHint: 'Pakuje materijalizovani rootfs u NOVU ct-rootfs datoteku u izabranom katalogu — šablon ostaje netaknut.',
    exportName: 'Ime datoteke',
    exportNameHint: 'Prazno = <template>-export-<n>',
    markCt: {
      action: 'Vrati u CT',
      confirmTitle: "Vratiti '{name}' u CT?",
      confirmBody: 'Šablon napušta ovu listu i vraća se u listu CT-ova, ponovo ga je moguće pokrenuti. Dok ga ponovo ne unapredite, iz njega se ne mogu kreirati novi CT-ovi.',
      confirm: 'Vrati u CT',
      moved: "'{name}' je ponovo običan CT — naći ćete ga u listi CT-ova."
    }
  },

  // OCI wave 1 (Annex Q — il modello tag-come-branch): un tag OCI è un branch
  // (puntatore mobile), il digest è il commit; refresh = "git fetch",
  // pull = risolvi ADESSO, scarica QUEL digest.
  oci: {
    registriesTitle: 'OCI registryji',
    imagesTitle: 'OCI slike',
    provider: 'Provider',
    providerDockerhub: 'Docker Hub',
    providerGhcr: 'GHCR',
    providerEcr: 'Amazon ECR',
    providerQuay: 'Red Hat Quay',
    providerGeneric: 'Generički',
    providerImmutableHint: 'Provider je nepromenljiv nakon kreiranja — drugačiji provider je novi registry.',
    url: 'URL',
    urlHintPreset: 'Unapred popunjen prema provideru — menjajte samo za mirrore.',
    urlHintRequired: 'Obavezan za generički registry: bazni https:// URL.',
    urlHintEcr: 'Obavezan: ECR endpointi su po nalogu/po regionu — preset ne postoji.',
    credential: 'Akreditiv',
    credentialNone: 'Anonimni pristup',
    credentialHint: 'Keystore stavka sa korisničkim imenom i lozinkom; workeri je razrešavaju u trenutku upotrebe — nikada auth datoteke po čvoru.',
    nameHint: 'Ime nalik hostu (docker.io, registry.intra); jedinstveno po scopeu, nepromenljivo',
    addRegistry: 'Dodaj registry',
    addRegistryTitle: 'Dodajte OCI registry',
    verify: 'Proveri',
    verifyState: 'Provera',
    verified: 'Proveren',
    verifyFailed: 'Neuspešna',
    neverVerified: 'Nikada proveren',
    registryInUseError: "'{name}' još ima registrovane repozitorijume — prvo ih obrišite.",
    repositories: 'Repozitorijumi',
    repositoriesHint: 'Registrovanje posmatra brancheve (OCI tagove) — ništa ne preuzima. Refresh razrešava svaki posmatrani branch i čuva reflog.',
    noRepositories: 'Nijedan repozitorijum nije registrovan na ovom registryju.',
    registerRepository: 'Registruj repozitorijum',
    repoPath: 'Putanja',
    repoPathHint: "Putanja repozitorijuma na registryju, npr. 'example' ili 'library/nginx'",
    branches: 'Branchevi',
    branchesHint: 'Posmatrani branchevi (OCI tagovi), odvojeni zarezom — npr. 1.1.0, 1.1.1',
    branch: 'Branch',
    branchPullHint: 'Razrešen SADA: pull preuzima digest na koji branch pokazuje danas.',
    refresh: 'Osveži',
    deleteRepository: 'Obriši repozitorijum',
    reflogCount: 'prethodnih: {n}',
    noResolutions: 'Nikada osvežen — još nema posmatranih razrešenja.',
    refreshFailed: 'Poslednje osvežavanje neuspešno ({when})',
    loadError: 'Repozitorijume nije moguće učitati.',
    reference: 'Referenca',
    digest: 'Digest',
    digestHint: 'sha256:… — tačna slika, bez brancha (detached)',
    size: 'Veličina',
    nodes: 'Čvorovi',
    detached: 'detached',
    detachedHint: 'Preuzeta po digestu, bez brancha — provera drifta se ne primenjuje.',
    pulledAt: 'Preuzeta',
    pull: 'Pull',
    pullTitle: 'Pull slike',
    pullHint: 'Pre-warming, nikada preduslov: pull po branchu razrešava SADA i preuzima TAJ digest; pull po digestu je detached.',
    pullError: 'Pull je odbijen',
    pullMode: 'Pull po',
    pullModeBranch: 'Branch (razreši sada)',
    pullModeDigest: 'Digest (detached)',
    pullModeBranchHint: 'Pošten podrazumevani izbor: kao apt install, ponovljen kasnije može dati drugačiju sliku.',
    pullModeDigestHint: 'Tačan digest — reproducibilnost i rollback; odriče se provere drifta.',

    // Il pattern a due pulsanti (#88, ratifica 2026-07-30 sera): "da
    // registry" è il pull guidato esistente, "da catalogo" materializza un
    // archivio oci-image pronto (la via air-gapped).
    importFromRegistry: 'Uvezi iz registryja',
    importFromCatalog: 'Uvezi iz kataloga',
    importCatalogTitle: 'Uvezite OCI sliku iz kataloga',
    importCatalogHint: 'Air-gapped put: spreman oci-image arhiv (tar/tar.gz — docker-archive ili oci-archive) materijalizuje se u store slika sa referencom catalog/<katalog>/<datoteka>@<digest>; aplikacije ga koriste kao bilo koju drugu sliku. Arhivi se otpremaju u kataloge — ovaj odeljak samo uvozi.',
    importCatalogFile: 'Arhiv',
    importCatalogFileHint: 'Spremne oci-image datoteke izabranog kataloga.',
    importCatalogNoFiles: 'Nema spremnog oci-image arhiva u ovom katalogu — otpremite jedan iz detalja kataloga.',
    importCatalogError: 'Uvoz je odbijen',
    registry: 'Registry',
    repository: 'Repozitorijum',
    cacheMissing: 'Klasterski OCI keš nije konfigurisan — pullovi se odbijaju dok ne podesite storage pool.',
    setCache: 'Podesi keš',
    setCacheTitle: 'Konfigurišite OCI keš',
    setCacheHint: 'PODRAZUMEVANI pool na nivou klastera koji čuva blobove preuzetih slika — scope može napraviti override sopstvenim poolom (stranica Scope). Promena se ne primenjuje u hodu i ništa ne restartuje, i nikada ne premešta blobove: oni se lenjo ponovo pojavljuju pri sledećem pokretanju/upotrebi.',
    cachePool: 'Storage pool',
    changeCache: 'Promeni keš',
    changeCacheTitle: 'Promenite pool OCI keša',
    cacheCurrent: 'OCI keš klastera (podrazumevani): {name}',
    sectionOverview: 'Pregled',
    sectionRepositories: 'Repozitorijumi',
    sectionExplore: 'Istraži',
    exploreHint: 'Udaljena pretraga uživo na registryju — Docker Hub puna (opis, preuzimanja, zvezdice), ostali provideri best-effort. Izaberite rezultat da pročitate njegov pun opis i pregledate njegove udaljene tagove; sa taga možete dodati referencu u TVirt repozitorijum.',
    exploreSearch: 'Pretraži',
    exploreUnsupported: 'Ovaj provider ne podržava pretragu.',
    exploreNoResult: 'Nijedan repozitorijum ne odgovara.',
    exploreNoTags: 'Nijedan tag ne odgovara na ovom repozitorijumu.',
    exploreOfficial: 'Zvanično',
    explorePulls: 'Preuzimanja',
    exploreStars: 'Zvezdice',
    exploreUpdated: 'Ažurirano {when}',
    exploreLoadMore: 'Učitaj još',
    exploreSelectHint: 'Izaberite rezultat: pun opis i udaljeni tagovi učitavaju se ovde.',
    exploreNoDescription: 'Nema dostupnog opisa od ovog providera.',
    exploreTagsTitle: 'Udaljeni tagovi',
    exploreTagFilter: 'Pretraži tagove',
    exploreAddToRepo: 'Dodaj u repozitorijum',
    exploreAdded: '{path}:{tag} se sada prati — pogledajte odeljak Repozitorijumi.',
    addBranch: 'Dodaj branch',
    purgeRequiredTitle: "Obrisati '{name}' i njegove slike?",
    purgeRequiredBody: 'Nijedna aplikacija ne koristi ovaj repozitorijum, ali preuzete slike još postoje: brisanje uklanja i njihove zapise, a keširane blobove čeka garbage collector.',
    purgeConfirm: 'Obriši i slike',
    providerSelectHint: 'Izaberite tip registryja: kartica opisuje preset i namenu.',
    providerDesc: {
      dockerhub: 'Javni Docker registry: unapred popunjen URL, puna pretraga sa opisima i brojačima.',
      ghcr: 'GitHub Container Registry: unapred popunjen URL; nalozi koriste personal access token.',
      ecr: 'Amazon Elastic Container Registry: endpointi po nalogu/po regionu — URL se mora navesti.',
      quay: 'Red Hat Quay registry: unapred popunjen URL.',
      generic: 'Self-hosted registry (Harbor, registry:2, …): https:// URL je obavezan.'
    },

    // Dialog standard (round #156): i campi del dettaglio immagine/registry
    // che le colonne non mostravano.
    layerCount: 'Layeri',
    verifiedAt: 'Poslednja provera',
    verifyOk: 'Ishod',
    verifyMessage: 'Poruka provere',

    // Model #348/R39: slika JESTE digest — sadržaj — a registry, spremište i grana su IMENA koja do njega vode.
    head: 'Head',
    heads: 'Glave po arhitekturi',
    listDigest: 'Dajdžest liste',
    neverResolved: 'Nikada razrešen',
    totalSize: 'Ukupna veličina',
    reflogTitle: 'Istorija razrešenja',
    usedBy: 'Koristi ga',
    usageLockfile: 'lockfile',
    usageRunning: 'u toku',
    evictable: 'podložan evikciji',
    evict: 'Evikcija iz keša',
    evictHeadTitle: 'Evikovati {digest}?',
    evictHeadBody: 'To je trenutno razrešenje bar jednog kolektora: evikovati ga je legitimno — to je samo keš, udaljeni branch ga i dalje služi — ali ne sme da se desi greškom. Blob je JEDAN: evikcija prazni sve kolektore koji ga dele.',
    evictConfirm: 'Ipak ga evikuj',

    arch: 'Arhitektura',
    names: 'Imena',
    noNames: 'bez imena',
    views: 'Prikazi',
    lastView: 'poslednji prikaz',
    evictLastViewTitle: 'Ukloniti poslednju referencu na {digest}?',
    evictLastViewBody: 'Ovo je poslednji prikaz ovog sadržaja: uklanjanjem slika prestaje da postoji na TVirt-u, a bajtovi ({size}) se oslobađaju. To je docker image rm ovog modela — nije sporedni efekat, već sama operacija.',
    branchesTabHint: 'Praćene grane ovog spremišta: za svaku današnje glave — po jedna za arhitekturu — hronologija osvežavanja i koliko njome imenovanih slika je u kešu. Osvežavanje je «git fetch» spremišta: razrešava sve njegove grane odjednom.',
    noBranches: 'U ovom spremištu se ne prati nijedna grana.',
    stopObserving: 'Prestani da pratiš granu',
    pullBranch: 'Preuzmi u keš glavu brancha (refresh razrešava, ovo preuzima)',
    pullDigest: 'Preuzmi ovaj digest u keš',
    imageCount: 'Slike',
    deleteBranchPurgeTitle: 'Ostaviti slike iz {name} bez imena?',
    deleteBranchPurgeBody: 'Nijedna aplikacija ne imenuje ovu granu, ali neke slike se dostižu samo preko nje: njenim brisanjem ostaju u kešu bez imena, navedene među slikama spremišta i uklonjive ručno.',
    deleteBranchPurgeConfirm: 'Obriši i ostavi slike bez imena',
    imagesTabHint: 'Slike ovog spremišta — sadržaji, to jest digesti — vidljive i bez izbora grane. Slika je jedinstvena po klasteru: imena koja do nje vode mogu biti više njih.',
    noImages: 'Nijedna slika ovog spremišta nije materijalizovana u kešu.',
    deleteRepositoryTitle: 'Obrisati {name}?',
    deleteRepositoryBody: 'Spremište i njegove grane nestaju sa svojom hronologijom. Slike ostaju u kešu: gube samo ovo ime. Spremište koje imenuje aplikacija ne može se obrisati.',
    provenanceCatalog: 'katalog',
    refreshedAt: 'Osveženo',
    neverRefreshed: 'Nikada osveženo',
    sectionBranches: 'Grane',
    sectionImages: 'Slike',
    repositoriesGovernedElsewhere: 'Ovde se spremišta samo gledaju: njihovo registrovanje, osvežavanje, praćenje grana i uklanjanje slika radi se u odeljku OCI slike.',
    gotoImages: 'Idi na OCI slike'
  },

  // Pod nativi (P1): the Pod list — the template's census of instances, the
  // whole-Pod lifecycle, the scale and the delete.
  pods: {
    title: 'Podovi',
    containers: 'Kontejneri',
    instances: 'Instance',
    instancesTooltip: '{running} pokrenuto, {error} u grešci',
    placement: 'Raspoređivanje',
    spread: 'raspodela',
    ha: 'HA',
    templateRevision: 'revizija',
    deleting: 'Briše se',
    empty: 'Nema podova — napravite aplikaciju (jedan kontejner) ili pod iz CLI-ja (create-pod).',
    openInstances: 'Otvori instance',
    rollingRestart: 'Postepeno ponovno pokretanje',
    scale: 'Skaliraj',
    scaleTitle: 'Skaliraj {name}',
    scaleHint: 'Broj instanci (0–64): naviše se popunjava najniži slobodni redni broj, naniže se povlači najviši, a njegovi trajni podaci ostaju.',
    scaleError: 'Skaliranje nije uspelo',
    replicas: 'Replike',
    deleteRunningError: '{name} je pokrenut — prvo ga zaustavite.',
    deleteInstancesIntro: 'Svih {count} instanci biće uklonjeno.',
    stateRunning: 'Pokrenut',
    stateStopped: 'Zaustavljen',
    editor: {
      createTitle: 'Napravi Pod',
      create: 'Napravi Pod',
      editTitle: 'Izmeni Pod',
      nameHint: 'DNS-1123, najviše 58 znakova — instance se zovu <ime>-<indeks>; nepromenljivo posle kreiranja.',
      restartPolicy: 'Politika restarta',
      restartPolicyHint_always: 'Čvor restartuje svaki izašli kontejner, sa eksponencijalnim backoff-om (10 s → 5 min).',
      restartPolicyHint_onFailure: 'Restartuje se samo kontejner koji je izašao sa kodom različitim od nule; izlaz 0 miruje.',
      restartPolicyHint_never: 'Izašli kontejner ostaje kakav jeste — instanca se završava kao succeeded ili failed.',
      grace: 'Odlaganje (s)',
      graceHint: 'Granica SIGTERM → SIGKILL zaustavljanja.',
      hostname: 'Ime hosta',
      hostnameHint: 'Prazno = ime instance.',
      hostnameDefault: 'ime instance',
      sharePid: 'Deli PID imenski prostor između kontejnera',
      containersIntro: 'Init kontejneri se izvršavaju do kraja, redom, pre nego što kontejneri krenu; kontejneri dele mrežu instance (jedan IP, localhost među njima).',
      initContainers: 'Init kontejneri',
      initAdd: 'Dodaj init kontejner',
      initHint: 'Svaki mora da izađe sa 0; neuspeh stavlja instancu u grešku, a čvor ga ponavlja sa backoff-om.',
      containerAdd: 'Dodaj kontejner',
      atLeastOne: 'Pod-u je potreban bar jedan kontejner.',
      duplicateNames: 'Imena kontejnera moraju biti jedinstvena u Pod-u (uključujući init kontejnere).',
      containerName: 'Ime kontejnera',
      containerInvalid: 'Ovaj kontejner je nepotpun: ime (DNS-1123), slika, montiranja na deklarisane volumene, brojčani limiti i sonda.',
      command: 'Komanda',
      commandHint: 'Zamenjuje entrypoint slike — jedan argument po redu, nikad shell string.',
      args: 'Argumenti',
      argsHint: 'Jedan po redu (CMD slike ako je prazno).',
      mounts: 'Montiranja',
      mountAdd: 'Dodaj montiranje',
      mountNoVolumes: 'Prvo deklarišite volumen u kartici Skladište.',
      readOnly: 'samo za čitanje',
      resources: 'Limiti',
      cpus: 'CPU',
      cpusHint: 'podman --cpus (npr. 1.5)',
      memory: 'Memorija (MiB)',
      memoryHint: 'podman --memory',
      health: 'Sonda živosti',
      healthCmd: 'Komanda sonde',
      healthCmdHint: 'Čvor je izvršava u kontejneru pri svakom nadzornom otkucaju — jedan argument po redu; izlaz 0 = zdravo.',
      healthTimeout: 'Vremensko ograničenje (s)',
      healthRetries: 'Pokušaji',
      healthRetriesHint: 'Uzastopni neuspesi pre nego što čvor restartuje kontejner.',
      ips: 'Statičke adrese',
      ipsHint: 'Jedna po instanci, po rednom broju — skaliranje van liste se odbija.',
      instance: 'instanca',
      volumesHint: 'Volumeni pripadaju Pod-u; putanja montiranja pripada svakom kontejneru (kartica Kontejneri).',
      spread: 'Raspodela',
      spreadHint_preferred: 'Instance na različitim čvorovima kad je moguće.',
      spreadHint_required: 'Instance na različitim čvorovima, inače skaliranje odbija.',
      spreadHint_none: 'Samo odlučivač.',
      ha: 'Visoka dostupnost (opt-in)',
      haHint: 'Svaki trajni deo na deljenom storage-u; ako čvor umre, HA decider ponovo stvara instance na drugom članu (automatski failover, kao kod HA VM-ova).',
      yes: 'da',
      no: 'ne'
    },
    detail: {
      container: 'Kontejner',
      actions: 'Radnje',
      ready: 'Spreman',
      notReady: 'Nije spreman',
      restarts: 'Restarti',
      lastRestartAt: 'Poslednji restart:',
      backoffUntil: 'Ponovni pokušaj u',
      stateAbsent: 'odsutan',
      stateRunning: 'radi',
      stateTerminated: 'završen',
      stateWaiting: 'čeka',
      init: 'init',
      noInstances: 'Nema instanci (replike 0).',
      ha: 'HA',
      haHint: 'Automatski failover: ako čvor umre, HA decider ponovo stvara instancu na drugom članu (svaki trajni deo na deljenom storage-u).',
      authority: 'Authority (čvor)',
      homeless: 'bez authority',
      homelessHint: 'Vraćanje iz checkpoint-a izostavlja authority (#380): nijedan čvor je ne opslužuje dok ne skalirate Pod (makar na isti broj replika).',
      restartContainer: 'Restartuj samo ovaj kontejner (pod ostaje aktivan)',
      divergingHint: 'Željeno stanje ove instance razlikuje se od podrazumevanog stanja Pod-a (PD-P19).',
      revisionLag: 'revizija {applied} primenjena od {current}',
      updatedInstances: '{updated}/{desired} instanci na ovoj reviziji'
    }
  }
}
